// actions
const SET = "timeLines/SET";
const SET_SELECTED = "timeLines/SET_SELECTED";
const SET_NEXT_TOKEN = "timeLines/SET_NEXT_TOKEN";
const SET_SELECTED_FILTERS = "timeLines/SET_SELECTED_FILTERS";

const DEFAULT_STATE = {
  listing: [],
  selected: "",

  nextToken: null,
  nextNextToken: undefined,
  previousTokens: [],
  selectedFilters: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    case SET_SELECTED_FILTERS:
      return Object.assign({}, state, { selectedFilters: action.listing });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });
export const setSelectedFilters = (listing: any[]) => ({
  listing,
  type: SET_SELECTED_FILTERS,
});
